import { toCancellationBusOrder } from './converter/BusOrderConverter'
import { toCancellationDomesticOrder } from './converter/DomesticOrderConverter'
import {
  toCancellationLeisureItem,
  toCancellationLeisureOrder,
} from './converter/LeisureOrderConverter'
import { toCancellationTrainOrder } from './converter/TrainOrderConverter'

const getCancellationOrderConverter = function () {
  return {
    toCancellationDomesticOrder,
    toCancellationLeisureOrder,
    toCancellationTrainOrder,
    toCancellationLeisureItem,
    toCancellationBusOrder,
  }
}

export default getCancellationOrderConverter
